import React from 'react';
import PropTypes from 'prop-types';

const PartenaireCard = ({ title, icon, color }) => {
  return (
    <div
      style={{
        backgroundColor: color,
        padding: '50px 0 50px 0',
        height: '100%',
      }}
    >
      <center>
        <i
          className="material-icons"
          style={{ fontSize: 60, color: 'white', marginBottom: 20 }}
        >
          {icon}
        </i>
        <div
          style={{
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            fontSize: 22,
            textAlign: 'center',
            color: '#FFFFFF',
            overflow: 'hidden',
          }}
        >
          {title}
        </div>
      </center>
    </div>
  );
};

PartenaireCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default PartenaireCard;



// WEBPACK FOOTER //
// ./src/components/Main/brand/PartenaireCard.js